module.exports = __webpack_public_path__ + "img/idea.aea2d161.png";